export default "__VITE_ASSET__CBirVc1S__"